import GnbPopupMenu from './GnbPopupMenuContainer';

export default GnbPopupMenu;
